import Service from "../../AuthService";

const Products = {
    getProduct(page) {
        return Service.get("/product?page=" + page);
    },
    getProducts(page) {
        return Service.get("/products-stock-log?page=" + page);
    },
    importExcel(data) {
        return Service.post("/products-stock-log-import", data);
    },
    getProductAll() {
        return Service.get("/product_all");
    },
    getSpecial(page) {
        return Service.get("/get_special?page=" + page);
    },
    getSpecialFactory(page) {
        return Service.get("/get_special_factory?page=" + page);
    },
    showSpecial(id) {
        return Service.get("/show_special/" + id);
    },
    showSpecialFactory(id) {
        return Service.get("/show_special_factory/" + id);
    },
    deleteSpecial(id) {
        return Service.get("/delete_special/" + id);
    },
    deleteSpecialFactory(id) {
        return Service.get("/delete_special_factory/" + id);
    },
    getProductAllSpecial(data) {
        return Service.get("/product_all_special?page=" + data.page + "&product=" + data.data.product + "&type=" + data.data.type);
    },
    getProductAllSpecialFactory(data) {
        return Service.get("/product_all_special_factory?page=" + data.page + "&product=" + data.data.product + "&type=" + data.data.type);
    },
    showProduct(id) {
        return Service.get("/product/" + id);
    },
    updateProduct(id, data) {
        return Service.put("/product/" + id, data);
    },
    createProduct(data) {
        return Service.post("/product", data);
    },
    saveSpecial(data) {
        return Service.post("/saveSpecial", data);
    },
    saveSpecialFactory(data) {
        return Service.post("/saveSpecial_factory", data);
    },
    deleteProduct(id) {
        return Service.delete("/product/" + id);
    },
    searchProduct(page, code, type, active) {
        return Service.post("/search-product?page=" + page + "&code=" + code + "&type=" + type + "&active=" + active);
    },
    searchWithSpecial(page, code, type, active, special) {
        return Service.get("/search-product-special?page=" + page + "&code=" + code + "&type=" + type + "&active=" + active + "&special=" + special);
    },
    searchProductStock(page, code, type, active) {
        return Service.post("/search-product-stock?page=" + page + "&code=" + code + "&type=" + type + "&active=" + active);
    },
    getPackProduct() {
        return Service.get('/pack-product');
    },
    updatePriceProduct(data) {
        return Service.get(`/update/update_product_price?product_type_id=${data.product_type_id}` +
            `&add_price_foam=${data.add_price_foam}&add_price_other=${data.add_price_other}` +
            `&reduce_price_foam=${data.reduce_price_foam}&reduce_price_other=${data.reduce_price_other}`
        )
    },
    updateCommissionProduct(data) {
        return Service.post('update_commission_product', data);
    },
    //getPromotionOption
    printProductPromotion(data) {
        return Service.post('report-product-pdf', data);
    },
    getPromotionOption() {
        return Service.get('promotion-option');
    },
    createQuota(data) {
        return Service.post('quota-sale-create', data);
    },
    indexQuota(data) {
        return Service.get(`quota-sale?page=${data.page}&view_all=${data.view_all}&sale_id=${data.sale_id}&date=${data.date}&product_type=${data.product_type}`);
    },
    listQuota(data) {
        return Service.get(`quota-sale-list?view_all=${data.view_all}&sale_id=${data.sale_id}&date=${data.date}&product_type=${data.product_type}`);
    },
    listQuotaHistory(data) {
        return Service.get(`quota-sale-list-history?page=${data.page}`);
    },
    editQuotaFix(data) {
        return Service.get(`quota-fix-edit?product=${data.product}&amount=${data.amount}&sale_id=${data.sale_id}&date=${data.date}`);
    }
};
export default Products;
